<template>
	<v-layout>
	<v-flex>
		
	</v-flex>
	</v-layout>
</template>

<script>

	
	
	export default {
		created()
		{
			if(!this.$store.getters['usersAuthorization/privilegesChecked'])
			{
				this.$store.dispatch('usersAuthorization/privileges')
			}
		}
	}



</script>